"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The SetUserPreferenceModel model module.
 * @module model/SetUserPreferenceModel
 * @version 1.1.3-alpha.1
 */
class SetUserPreferenceModel {
  /**
   * Constructs a new <code>SetUserPreferenceModel</code>.
   * @alias module:model/SetUserPreferenceModel
   */
  constructor() {
    SetUserPreferenceModel.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>SetUserPreferenceModel</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SetUserPreferenceModel} obj Optional instance to populate.
   * @return {module:model/SetUserPreferenceModel} The populated <code>SetUserPreferenceModel</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SetUserPreferenceModel();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
      }
      if (data.hasOwnProperty('value')) {
        obj['value'] = _ApiClient.default.convertToType(data['value'], Object);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>SetUserPreferenceModel</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SetUserPreferenceModel</code>.
   */
  static validateJSON(data) {
    return true;
  }
}

/**
 * @member {Number} id
 */
SetUserPreferenceModel.prototype['id'] = undefined;

/**
 * @member {Object} value
 */
SetUserPreferenceModel.prototype['value'] = undefined;
var _default = exports.default = SetUserPreferenceModel;